import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  SearchInput,
  Box,
  Text,
} from '@wegroup/design-system';
import { InsurancePolicyClause } from '../../../../../../../types/AdvisoryReport';
import { useTranslation } from 'react-i18next';
import InsurancePolicyClauseItem from './InsurancePolicyClauseItem';

interface Props {
  clauses?: InsurancePolicyClause[];
  isOpen: boolean;
  onClose: () => void;
}

const InsurancePolicyClausesModal: React.FC<Props> = ({
  clauses = [],
  onClose,
  isOpen,
}) => {
  const { t } = useTranslation();
  const [searchVal, setSearchVal] = useState<string>('');

  const filteredClauses = clauses.filter(
    ({ title, description }) =>
      title?.toLowerCase().includes(searchVal) ||
      description?.toLowerCase().includes(searchVal),
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('INSURANCE-POLICIES_CLAUSES_TITLE')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pt="4">
          <VStack align="stretch" spacing="4">
            <Box
              bg="gray.ultraLight"
              borderRadius="md"
              border="1px"
              p="2"
              borderColor="gray.strokeAndBg"
            >
              <Box
                bg="white"
                borderRadius="md"
                border="1px"
                px="2"
                borderColor="gray.strokeAndBg"
              >
                <SearchInput
                  value={searchVal}
                  onChange={(e) => setSearchVal(e.currentTarget.value)}
                />
              </Box>
            </Box>
            <VStack align="stretch" spacing="2">
              {filteredClauses.map((clause, i) => (
                <InsurancePolicyClauseItem
                  key={clause.id}
                  data={clause}
                  indexNumber={
                    clauses.findIndex(({ id }) => clause.id === id) + 1
                  }
                />
              ))}
            </VStack>
            {filteredClauses.length === 0 && (
              <Text color="gray.500" align="center" pt="3">
                {t('NO-RESULTS-FOUND')}
              </Text>
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default InsurancePolicyClausesModal;
